import Vue from 'vue'
import Router from 'vue-router'
//前台
import About from '../../Views/About'
import Album from '../../Views/Album'
import TimeList from '../../Views/TimeList'
import Link from '../../Views/Link'
//后台
import Writing from "../../Views/Writing";

Vue.use(Router);

const routes = [
    {
        path: '/',
        component: About
    },
    {
        path: '/About',
        component: About
    },
    {
        path: '/Album',
        component: Album
    },
    {
        path: '/TimeList',
        component: TimeList
    },
    {
        path: '/Link',
        component: Link
    },
    {
        path: '/Writing',
        component: Writing
    }
];

const router = new Router({
    mode: "history",
    routes
});

export default router